import { DetailRequirement } from '@cibo/core'
import { ResourceDetailFeatureTaskEditorProps } from '@cibo/ui'
import { Stack } from '@mui/material'
import { TraitTable } from '../../../components'
import { useFields } from '../../../queries'

/**
 * Assumptions:
 * 1. you will only pass a single resourceId in the resourceIds array
 * 2. there will only ever be a single detail for a given resourceId
 */
export const TraitTableTaskEditor = ({
  detailRequirements,
  resourceIds,
  onUpdating,
  onError,
  onSuccess,
  ownerName,
  // @ts-ignore is already passed but ts says not part of type
  engagement,
}: ResourceDetailFeatureTaskEditorProps<any>) => {
  const fields = useFields(resourceIds)

  return (
    <Stack>
      <TraitTable
        programIds={[engagement.programId]}
        detailRequirements={detailRequirements as DetailRequirement[]}
        fieldModels={fields.data || []}
        traitId={detailRequirements[0].traitId}
        loading={fields.isLoading}
        growerName={ownerName}
      />
    </Stack>
  )
}
